/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import UiCheckbox from 'components/Ui/UiCheckbox'
import UiTextarea from 'components/Ui/UiTextarea'
import UiButton, { UiButtonSize, UiButtonStyle } from 'components/Ui/UiButton'
import {useTranslation} from "react-i18next";
import {useRejectedReasons} from 'utils/hooks/useRejectedReasons'
import { useAppDispatch } from 'helpers/store'
import { closeModal, openModal } from 'helpers/actions'
import { ModalSize } from 'types/enums/ModalSize'
import RejectionReasonsCatalogModal from './RejectionReasonsCatalogModal'

interface OfferRejectionReasonsListProps {
    selectedReasons: string[]
    isOtherReasonSelected: boolean
    otherReasonComment: string
    onToggleReason: (reasonId: string) => void
    onOtherReasonCommentChange: (value: string) => void
}

const OfferRejectionReasonsList = (props: OfferRejectionReasonsListProps) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const { reasons } = useRejectedReasons()
    if (!reasons.length) {
        return null
    }

    return (
        <div className="OfferRejectionReasonsList">
            {reasons.map((reason) => (
                <div key={reason.id} className="flex flex-col">
                    <UiCheckbox
                        name={`reason_${reason.id}`}
                        label={reason.label}
                        checked={props.selectedReasons.includes(reason.id)}
                        onChange={() => props.onToggleReason(reason.id)}
                    />
                    {reason.id === 'other' && props.isOtherReasonSelected && (
                        <div className="ml-7 mt-2">
                            <UiTextarea
                                name="other_reason_comment"
                                placeholder={t('Specific reason...')}
                                value={props.otherReasonComment}
                                onChange={(e) => props.onOtherReasonCommentChange(e.target.value)}
                                required
                            />
                        </div>
                    )}
                </div>
            ))}
            <div className="pt-2">
                <UiButton
                    size={UiButtonSize.Small}
                    style={UiButtonStyle.Secondary}
                    title={t('Manage catalog') as string}
                    onClick={() =>
                        dispatch(
                            openModal(
                                <RejectionReasonsCatalogModal
                                    onClose={() => dispatch(closeModal())}
                                />,
                                {
                                    modalSize: ModalSize.Medium,
                                    closeModal: () => dispatch(closeModal()),
                                },
                                t('Rejection reasons catalog')
                            )
                        )
                    }
                />
            </div>
        </div>
    )
}

export default OfferRejectionReasonsList
